import {
  differenceInCalendarDays,
  format,
  formatDistanceToNowStrict,
  isToday,
  isYesterday,
  parseISO,
} from "date-fns";

/** "2m ago", "3h ago", "4d ago" — short enough for a feed row. */
export function relativeTime(iso: string): string {
  const date = parseISO(iso);
  const seconds = (Date.now() - date.getTime()) / 1000;
  if (seconds < 60) return "just now";
  return `${formatDistanceToNowStrict(date, { roundingMethod: "floor" })
    .replace(" seconds", "s")
    .replace(" second", "s")
    .replace(" minutes", "m")
    .replace(" minute", "m")
    .replace(" hours", "h")
    .replace(" hour", "h")
    .replace(" days", "d")
    .replace(" day", "d")
    .replace(" months", "mo")
    .replace(" month", "mo")
    .replace(" years", "y")
    .replace(" year", "y")} ago`;
}

export function dayLabel(iso: string): string {
  const date = parseISO(iso);
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "EEE d MMM");
}

export function todayIso(): string {
  return format(new Date(), "yyyy-MM-dd");
}

/** The device's IANA zone, stored on the profile so nudges land in the evening. */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function periodLabel(cadence: "daily" | "weekly"): string {
  return cadence === "daily" ? "today" : "this week";
}

/**
 * How a goal's cadence is written in the interface: "daily", "3x/day",
 * "4x/wk". Terse and lowercase, the way the design writes it under a name.
 */
export function cadenceLabel(cadence: "daily" | "weekly", target: number): string {
  if (cadence === "weekly") return `${target}x/wk`;
  return target === 1 ? "daily" : `${target}x/day`;
}

/** Whole days between an ISO timestamp and now, floored at zero. */
export function daysSince(iso: string): number {
  return Math.max(0, differenceInCalendarDays(new Date(), parseISO(iso)));
}
